import { Moon, Sun } from 'lucide-react';
import { useWakeLock } from '../hooks/useWakeLock';

export default function WakeLockToggle({ variant = 'dark', testIdPrefix = 'wake-lock' }) {
  const { enabled, active, supported, error, toggle } = useWakeLock();
  const Icon = enabled ? Sun : Moon;
  const label = !supported ? 'Awake unsupported' : active ? 'Awake on' : enabled ? 'Awake paused' : 'Keep awake';
  const title = !supported
    ? 'This device or browser does not support screen wake lock. Use device auto-lock or kiosk settings.'
    : active
      ? 'Screen dimming is being prevented while this view stays open.'
      : 'Keep this screen awake while this view is open.';

  const base = 'inline-flex items-center gap-1.5 rounded-lg border px-2.5 py-1.5 font-mono text-[10px] font-bold uppercase tracking-wider transition-colors disabled:cursor-not-allowed disabled:opacity-50';
  const styles = variant === 'light'
    ? active
      ? 'border-[#4A7C3F] bg-[#E8F0E4] text-[#1B3A1A] hover:bg-[#D9E9D3]'
      : 'border-[#7D8B69]/30 bg-white text-[#4A5D4E] hover:bg-[#F3F0E6]'
    : active
      ? 'border-[#B8860B] bg-[#B8860B] text-white hover:brightness-95'
      : 'border-white/20 bg-white/5 text-white/60 hover:bg-white/10 hover:text-white';

  return (
    <div className="flex items-center gap-2" data-testid={`${testIdPrefix}-control`}>
      <button
        type="button"
        onClick={toggle}
        disabled={!supported}
        aria-pressed={enabled}
        title={title}
        className={`${base} ${styles}`}
        data-testid={`${testIdPrefix}-toggle`}
      >
        <Icon size={14} />
        <span data-testid={`${testIdPrefix}-status`}>{label}</span>
      </button>
      {enabled && error && (
        <span className={`font-mono text-[10px] ${variant === 'light' ? 'text-[#B8860B]' : 'text-[#B8860B]'}`} data-testid={`${testIdPrefix}-message`}>
          {error}
        </span>
      )}
    </div>
  );
}
